import React from 'react';
import Nav from '../components/Nav';

export default function Toolbar() {
  return (
    <section className='toolbar'>
      <span className='welcome'>Welcome</span>
      <Nav />
    </section>
  );
}
